import { QueryClient, useMutation } from "@tanstack/react-query"
import { AbsencePost, AbsenceType } from "../types"
import { addAbsence, solveConflictAbsence, updateAbsenceById } from "./apiCalls"
import { useState } from "react"
import { messageError, messagePending, messageSuccess } from "../../../services/messages"
import { apiErrorMessage } from "../../../services/apiErrorText"

// ADD ABSENCE
export const useAddAbsenceMutation = (queryClient: QueryClient, queryKey: string) => {
    const [notificationKey, setnotificationKey] = useState<string>("")
    const mutation = useMutation<unknown, Error, AbsencePost>({
        mutationFn: addAbsence,
        onMutate: () => {
            const newKey = Math.random().toString(36).substring(2, 12)
            setnotificationKey(newKey)
            messagePending(newKey, "In Bearbeitung...", "Die Abwesenheit wird gerade hinzugefügt.")
        },
        onSuccess: () => {
            messageSuccess(notificationKey, "Fertig!", "Die Abwesenheit wurde erfolgreich hinzugefügt.")
            queryClient.invalidateQueries({
                queryKey: [queryKey],
            })
        },
        onError: (err) => {
            messageError(notificationKey, "Fehler!", apiErrorMessage(err, "Die Abwesenheit konnte nicht hinzugefügt werden."))
            console.log(err)
        },
    })

    return mutation
}

// Update Absence
export const useUpdateAbsence = (queryClient: QueryClient, queryKey: string) => {
    const [notificationKey, setnotificationKey] = useState<string>("")
    const mutation = useMutation<unknown, Error, { id: string; body: AbsenceType }>({
        mutationFn: updateAbsenceById,
        onMutate: () => {
            const newKey = Math.random().toString(36).substring(2, 12)
            setnotificationKey(newKey)
            messagePending(newKey, "In Bearbeitung...", "Die Abwesenheit wird gerade aktualisiert.")
        },
        onSuccess: () => {
            messageSuccess(notificationKey, "Fertig!", "Die Abwesenheit wurde erfolgreich aktualisiert.")
            queryClient.invalidateQueries({
                queryKey: [queryKey],
            })
        },
        onError: (err) => {
            messageError(notificationKey, "Fehler!", apiErrorMessage(err, "Die Abwesenheit konnte nicht aktualisiert werden."))
            console.log(err)
        },
    })

    return mutation
}

// Solve Conflict Absence
export const useSolveConflictAbsence = (queryClient: QueryClient, queryKey: string) => {
    const [notificationKey, setnotificationKey] = useState<string>("")
    const mutation = useMutation<unknown, Error, { parentId: string; conflictId: string }>({
        mutationFn: solveConflictAbsence,
        onMutate: () => {
            const newKey = Math.random().toString(36).substring(2, 12)
            setnotificationKey(newKey)
            messagePending(newKey, "In Bearbeitung...", "Die Abwesenheit wird gerade aktualisiert.")
        },
        onSuccess: () => {
            messageSuccess(notificationKey, "Fertig!", "Die Abwesenheit wurde erfolgreich aktualisiert.")
            queryClient.invalidateQueries({
                queryKey: [queryKey],
            })
        },
        onError: (err) => {
            messageError(notificationKey, "Fehler!", apiErrorMessage(err, "Die Abwesenheit konnte nicht aktualisiert werden."))
            console.log(err)
        },
    })

    return mutation
}
